// Module
var code = "<cr-row-builder rows=\"$ctrl.model\" add-text=\"{{ ::$ctrl.text.addExtension }}\" data-global-qa-id=\"add-extension\" on-change=\"$ctrl.onChange({ $event: $event })\"> <cr-extensions-builder-row row=\"row\" rows=\"rows\"></cr-extensions-builder-row> </cr-row-builder> ";
// Exports
export default code;